(async () => {
  class ProductList extends HTMLElement {
    constructor() {
      super();
      this.type = this.dataset.type;
    }

    connectedCallback() {
      this.init();
      this.initWishlist();
      this.adjustCollapsible();
    }

    init() {
      // Bind toggle filters panel events
      this.addEventListener('click', (event) => {
        // Open/close filters panel
        if (event.target.closest('[data-list-filters-toggle-panel-btn]')) {
          this.toggleFiltersPanel(event.target.dataset.listFiltersTogglePanelBtn);

          if (event.target.dataset.listFiltersTogglePanelBtn === 'close') {
            window.scrollTo({
              top: 0,
              behavior: 'smooth',
            });
          }
        }

        // Set facet active state, before the filter is submitted
        const facet = event.target.closest('.list-facet__item');
        if (facet) {
          const input = facet.querySelector('input');
          if (input) {
            facet.classList.toggle('list-facet__item--selected', input.checked);
          } else if (facet.dataset.value) {
            facet.classList.toggle('list-facet__item--selected', !facet.classList.contains('list-facet__item--selected'));
          }
        }
      });

      // Bind click on body to close collapsed filters (on desktop)
      document.addEventListener('click', (event) => {
        const collapsibleSelector = 'collapsible-element.list-toolbar__collapsible';
        const filtersCollapsible = document.querySelector(collapsibleSelector);

        if (window.innerWidth >= 768 && filtersCollapsible) {
          const isOutside = !event.target.closest(collapsibleSelector);
          if (isOutside) {
            filtersCollapsible.closeAll();
          }
        }
      });
    }

    initWishlist() {
      const callbackFn = (swat) => {
        swat.evtLayer.addEventListener(swat.JSEvents.addedToWishlist, (event) => {
          const product = event?.detail?.d;
          if (!product) return;

          const notification = `
              <div class="swym-notifications-container swymTopLeft">
                <a href="/pages/swym-wishlist" class="swym-notification-wishlist swym-clickable">
                  <div class="swym-product-tile">
                    <button class="swym-close-btn swym-is-button">
                      <svg class="swym-icon icon icon-close icon--xs" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="presentation" viewBox="0 0 24 24">
                        <title>Close</title>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M18.1,17.1c0.3,0.3,0.3,0.8,0,1.1s-0.8,0.3-1.1,0L12,13.1l-5.1,5.1c-0.3,0.3-0.8,0.3-1.1,0
                        c-0.3-0.3-0.3-0.8,0-1.1l5.1-5.1L5.9,6.9c-0.3-0.3-0.3-0.8,0-1.1s0.8-0.3,1.1,0l5.1,5.1l5.1-5.1c0.3-0.3,0.8-0.3,1.1,0
                        c0.3,0.3,0.3,0.8,0,1.1l0,0L13.1,12L18.1,17.1z"></path>
                      </svg>
                    </button>
                    <img class="swym-image" src="${product.iu}" alt="">
                    <div class="swym-details-container">
                      <div class="swym-details" role="alert">
                        <strong>${product.dt}</strong> has been added to your wishlist successfully.
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            `;

          const container = document.querySelector('.swym-wishlist-notifications-container');
          if (!container) return;

          container.innerHTML = notification;
          const popup = container.querySelector('.swym-notifications-container');

          setTimeout(() => {
            if (popup) popup.classList.add('swym-showing');
          }, 250);

          setTimeout(() => {
            if (popup) popup.classList.remove('swym-showing');
          }, 6000);

          const closeBtn = container.querySelector('.swym-close-btn');
          if (closeBtn) {
            closeBtn.addEventListener('click', (e) => {
              e.preventDefault();
              popup.classList.remove('swym-showing');
            });
          }
        });
      };

      if (!window.SwymCallbacks) {
        window.SwymCallbacks = [];
      }
      window.SwymCallbacks.push(callbackFn);
    }

    adjustCollapsible() {
      const filtersCollapsible = this.querySelector('collapsible-element.list-toolbar__collapsible');
      if (!filtersCollapsible) return;

      const breakpoint = window.matchMedia('(max-width: 768px)');
      const update = (bp) => {
        if (bp.matches) {
          filtersCollapsible.options.closeSiblings = false;
        } else {
          filtersCollapsible.options.closeSiblings = true;
          this.toggleFiltersPanel('close');
        }
      };

      breakpoint.addEventListener('change', update);
      update(breakpoint);
    }

    toggleFiltersPanel(action = 'close') {
      const filtersSelector = '.list-toolbar__filters';
      const activeClass = 'list-toolbar__filters--is-active';
      const overflowClass = 'overflow-hidden';
      const facets = this.querySelector(filtersSelector);
      const filtersCollapsible = this.querySelector('collapsible-element.list-toolbar__collapsible');

      if (!facets || !filtersCollapsible) return;

      switch (action) {
        case 'open':
          facets.classList.add(activeClass);
          document.body.classList.add(overflowClass);

          // If mobile width, open collapsible groups that have filters active
          if (window.innerWidth < 768) {
            const filterGroupSelector = '[data-collapsible-group]';
            const activeFilterSelector = '.options__input:checked, .field__input[value]:not([value=""])';
            const activeFilters = filtersCollapsible.querySelectorAll(activeFilterSelector);

            activeFilters.forEach((activeFilter) => {
              const filterGroup = activeFilter.closest(filterGroupSelector);
              if (filterGroup) filtersCollapsible.open(filterGroup);
            });
          }
          break;
        case 'close':
        default:
          facets.classList.remove(activeClass);
          document.body.classList.remove(overflowClass);
          filtersCollapsible.closeAll();
      }
    }
  }

  customElements.define('product-list', ProductList);
})();
